import HighchartsChart from './HighchartsChart';
export default HighchartsChart;